var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnboardingSuccessArt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 287.451,
    height: 220.118,
    viewBox: "0 0 287.451 220.118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.149,
    y1: -0.519,
    x2: 5.596,
    y2: 5.672,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ce1567"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a1dbc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.027,
    y1: -1.94,
    x2: 2.979,
    y2: 6.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1.57,
    y1: -3.799,
    x2: -2.811,
    y2: 1.804,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a737d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef497a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26637",
    "data-name": "Group 26637",
    transform: "translate(-1497.115 -1676.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8004",
    "data-name": "Path 8004",
    d: "M321.13,367.142s-97.6,1.135-124.788-24.4-16.953-50.984,3.863-58.194,24.367-14.709,13.166-24.823-25.427-30.877-1.806-51.742,50.572,9.1,71.683,5.125,18.574-27.5,40.512-8.126c25.8,22.779,21.641-17.694,43.96-20.137s20.031,28.031,42.988,16.528,41.735-9.916,51.6,8.353,5.583,42.873-16.07,57.537-19.329,13.664-11.236,28.073,15.348,61.793-21.491,68.561S321.13,367.142,321.13,367.142Z",
    transform: "translate(1317.221 1522.634)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26631",
    "data-name": "Group 26631",
    transform: "matrix(0.602, -0.799, 0.799, 0.602, 1615.126, 1741.183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11879",
    "data-name": "Group 11879",
    transform: "translate(17.959 37.823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3674",
    "data-name": "Path 3674",
    d: "M.4,1.427A.4.4,0,0,1,.243.667c.479-.2.96-.411,1.43-.631a.395.395,0,1,1,.334.716c-.48.224-.972.441-1.461.644A.393.393,0,0,1,.4,1.427Z",
    transform: "translate(52.132 50.709)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3675",
    "data-name": "Path 3675",
    d: "M38.009,48.652c-.662,0-1.333-.018-1.993-.052a.4.4,0,0,1-.374-.415.4.4,0,0,1,.415-.374c1.052.055,2.116.066,3.179.032h.013a.4.4,0,0,1,.013.79Q38.633,48.653,38.009,48.652Zm6.431-.546a.395.395,0,0,1-.066-.784c1.044-.179,2.09-.4,3.108-.669a.4.4,0,1,1,.2.765c-1.04.271-2.108.5-3.174.683A.4.4,0,0,1,44.44,48.106Zm-13.581-.139a.379.379,0,0,1-.075-.007c-1.056-.2-2.119-.459-3.157-.754a.4.4,0,1,1,.216-.76c1.016.29,2.056.539,3.09.739a.4.4,0,0,1-.075.783Zm-8.032-2.524a.391.391,0,0,1-.16-.034c-.987-.437-1.965-.922-2.91-1.441a.395.395,0,0,1,.381-.692c.924.508,1.883.982,2.849,1.411a.4.4,0,0,1-.16.756ZM15.559,41.2a.394.394,0,0,1-.236-.078c-.864-.644-1.712-1.333-2.518-2.049a.4.4,0,0,1,.524-.591c.79.7,1.619,1.375,2.466,2.006a.395.395,0,0,1-.236.712ZM9.412,35.447a.394.394,0,0,1-.3-.138c-.7-.821-1.375-1.68-2-2.554a.4.4,0,1,1,.642-.461c.614.857,1.274,1.7,1.961,2.5a.4.4,0,0,1-.3.652Zm-4.72-6.965a.4.4,0,0,1-.35-.211c-.5-.954-.966-1.942-1.382-2.935a.395.395,0,1,1,.728-.306c.409.973.864,1.94,1.354,2.874a.395.395,0,0,1-.349.578ZM1.646,20.638a.4.4,0,0,1-.381-.294C.989,19.3.756,18.236.571,17.174a.4.4,0,0,1,.779-.136c.181,1.04.41,2.085.678,3.1a.4.4,0,0,1-.281.483A.407.407,0,0,1,1.646,20.638ZM.42,12.312a.4.4,0,0,1-.395-.381Q0,11.243,0,10.56C0,9.935.015,9.3.046,8.684A.39.39,0,0,1,.46,8.309a.4.4,0,0,1,.375.414C.806,9.33.79,9.948.79,10.56q0,.669.024,1.343a.4.4,0,0,1-.381.409Zm.64-8.395a.394.394,0,0,1-.388-.469c.2-1.059.453-2.122.745-3.16A.4.4,0,1,1,2.176.5C1.89,1.518,1.645,2.56,1.447,3.6A.4.4,0,0,1,1.059,3.917Z",
    transform: "translate(0 6.369)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3676",
    "data-name": "Path 3676",
    d: "M.395,2.222a.395.395,0,0,1-.361-.554C.245,1.187.472.7.707.22a.4.4,0,0,1,.709.349c-.231.469-.452.946-.659,1.416A.4.4,0,0,1,.395,2.222Z",
    transform: "translate(3.174 0)",
    fill: "#d7d6e2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11880",
    "data-name": "Group 11880",
    transform: "translate(42.635 16.779)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3677",
    "data-name": "Path 3677",
    d: "M.4,1.3A.4.4,0,0,1,.259.537C.76.353,1.268.18,1.77.019a.4.4,0,0,1,.24.753c-.491.157-.989.327-1.479.507A.4.4,0,0,1,.4,1.3Z",
    transform: "translate(0 1.748)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3678",
    "data-name": "Path 3678",
    d: "M42.609,50.365a.395.395,0,0,1-.375-.521c.33-.983.623-1.994.869-3a.4.4,0,0,1,.768.187c-.252,1.032-.55,2.065-.887,3.07A.4.4,0,0,1,42.609,50.365Zm1.748-8.1-.041,0a.4.4,0,0,1-.353-.433c.106-1.034.168-2.085.186-3.123a.39.39,0,0,1,.4-.388.4.4,0,0,1,.388.4c-.019,1.06-.083,2.134-.19,3.189A.4.4,0,0,1,44.357,42.268Zm-.07-8.285a.4.4,0,0,1-.392-.349c-.122-1.034-.288-2.072-.494-3.087a.395.395,0,1,1,.774-.157c.211,1.037.38,2.1.5,3.152a.4.4,0,0,1-.346.439Zm-1.862-8.068a.4.4,0,0,1-.373-.264c-.344-.98-.734-1.957-1.159-2.9a.4.4,0,0,1,.721-.323c.434.967.833,1.965,1.184,2.966a.4.4,0,0,1-.242.5A.387.387,0,0,1,42.424,25.915Zm-3.588-7.459a.4.4,0,0,1-.335-.185c-.551-.88-1.146-1.748-1.769-2.578a.4.4,0,0,1,.632-.474c.636.849,1.244,1.734,1.806,2.633a.4.4,0,0,1-.125.544A.389.389,0,0,1,38.837,18.456ZM33.7,11.963a.4.4,0,0,1-.281-.117c-.73-.74-1.5-1.457-2.288-2.132a.4.4,0,1,1,.514-.6c.8.689,1.591,1.422,2.337,2.177a.4.4,0,0,1-.281.673ZM27.27,6.741a.4.4,0,0,1-.213-.063c-.875-.564-1.783-1.1-2.7-1.583a.4.4,0,1,1,.37-.7c.935.5,1.862,1.04,2.755,1.616a.4.4,0,0,1-.215.727Zm-7.413-3.7a.392.392,0,0,1-.136-.024c-.975-.358-1.977-.679-2.98-.953a.4.4,0,0,1,.209-.763c1.024.281,2.047.608,3.043.974a.395.395,0,0,1-.136.766ZM.395,1.316A.4.4,0,0,1,.327.531C1.369.35,2.434.21,3.494.115A.4.4,0,1,1,3.564.9c-1.038.092-2.082.23-3.1.407A.406.406,0,0,1,.395,1.316ZM11.81,1.068a.379.379,0,0,1-.052,0C10.729.93,9.681.838,8.643.791A.4.4,0,0,1,8.68,0c1.059.049,2.129.143,3.181.28a.4.4,0,0,1-.051.787Z",
    transform: "translate(6.481 0)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3679",
    "data-name": "Path 3679",
    d: "M.395,2.19A.4.4,0,0,1,.049,1.6C.3,1.146.544.681.774.219a.4.4,0,0,1,.708.352c-.234.471-.483.946-.74,1.414A.4.4,0,0,1,.395,2.19Z",
    transform: "translate(45.99 54.341)",
    fill: "#d7d6e2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11881",
    "data-name": "Group 11881",
    transform: "translate(26.615 25.713)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3680",
    "data-name": "Path 3680",
    d: "M52.795,46.085a.453.453,0,0,0,.061-.522L50.2,40.746a23.959,23.959,0,0,0,2.61-7.311l5.1-2.05a.452.452,0,0,0,.283-.442l-.33-6.59a.452.452,0,0,0-.325-.411l-5.28-1.53A23.966,23.966,0,0,0,48.932,15.4l2.158-5.059a.451.451,0,0,0-.113-.512L46.085,5.4a.453.453,0,0,0-.521-.061L40.746,7.994a23.961,23.961,0,0,0-7.311-2.61l-2.05-5.1A.452.452,0,0,0,30.943,0l-6.59.33a.451.451,0,0,0-.411.326l-1.53,5.28A23.957,23.957,0,0,0,15.4,9.264L10.34,7.106a.452.452,0,0,0-.512.113L5.4,12.111a.452.452,0,0,0-.061.521L7.995,17.45a23.949,23.949,0,0,0-2.611,7.311l-5.1,2.049A.453.453,0,0,0,0,27.253l.33,6.59a.452.452,0,0,0,.326.411l5.28,1.53A23.939,23.939,0,0,0,9.265,42.8L7.106,47.856a.452.452,0,0,0,.113.512l4.893,4.426a.452.452,0,0,0,.521.061L17.451,50.2a23.958,23.958,0,0,0,7.311,2.61l2.05,5.1a.451.451,0,0,0,.441.283l6.59-.33a.452.452,0,0,0,.411-.326l1.53-5.28A23.956,23.956,0,0,0,42.8,48.932l5.059,2.158a.452.452,0,0,0,.513-.113Z",
    transform: "translate(0 0)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3681",
    "data-name": "Path 3681",
    d: "M6.458,12.906a6.452,6.452,0,1,1,1.887-.283A6.462,6.462,0,0,1,6.458,12.906Zm0-11.72a5.3,5.3,0,0,0-1.55.234,5.266,5.266,0,1,0,6.578,3.492h0A5.275,5.275,0,0,0,6.461,1.186Z",
    transform: "translate(22.644 22.644)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3682",
    "data-name": "Path 3682",
    d: "M16.5,33.026A16.533,16.533,0,0,1,.021,17.339Q0,16.919,0,16.5a16.513,16.513,0,0,1,33.006-.818q.02.417.021.835A16.628,16.628,0,0,1,32.81,19.2L31.641,19a15.415,15.415,0,0,0,.2-2.484q0-.388-.02-.775h0A15.328,15.328,0,0,0,1.185,16.5q0,.39.02.782A15.331,15.331,0,0,0,25.032,29.258l.66.985a16.488,16.488,0,0,1-8.352,2.763Q16.92,33.026,16.5,33.026Z",
    transform: "translate(12.473 12.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3683",
    "data-name": "Path 3683",
    d: "M30.336,24.477,28.64,21.9a13.427,13.427,0,0,0,1.134-4.2l2.758-1.371a.253.253,0,0,0,.138-.259l-.477-3.666a.254.254,0,0,0-.2-.215l-3.017-.62A13.423,13.423,0,0,0,26.805,7.8l.981-2.921A.254.254,0,0,0,27.7,4.6L24.771,2.346a.253.253,0,0,0-.294-.011L21.9,4.032a13.415,13.415,0,0,0-4.2-1.133L16.334.14A.253.253,0,0,0,16.075,0L12.409.479a.253.253,0,0,0-.216.2L11.573,3.7A13.425,13.425,0,0,0,7.8,5.866L4.882,4.885a.253.253,0,0,0-.281.086L2.347,7.9a.252.252,0,0,0-.011.294l1.7,2.573a13.419,13.419,0,0,0-1.133,4.2L.141,16.338A.254.254,0,0,0,0,16.6l.477,3.666a.253.253,0,0,0,.2.215L3.7,21.1a13.425,13.425,0,0,0,2.17,3.769l-.981,2.921a.253.253,0,0,0,.086.281L7.9,30.325a.254.254,0,0,0,.294.011l2.573-1.7a13.431,13.431,0,0,0,4.2,1.133l1.371,2.758a.253.253,0,0,0,.26.138l3.666-.477a.254.254,0,0,0,.215-.2l.62-3.017a13.432,13.432,0,0,0,3.769-2.171l2.921.981a.254.254,0,0,0,.281-.085l2.255-2.93A.253.253,0,0,0,30.336,24.477Z",
    transform: "translate(3.818 3.813)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3684",
    "data-name": "Path 3684",
    d: "M3.877,7.752a3.876,3.876,0,1,1,3.6-5.3h0a3.88,3.88,0,0,1-3.6,5.3Zm0-6.567a2.69,2.69,0,1,0,2.5,1.7A2.683,2.683,0,0,0,3.874,1.185Z",
    transform: "translate(16.277 16.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11883",
    "data-name": "Group 11883",
    transform: "translate(0 16.571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3685",
    "data-name": "Path 3685",
    d: "M.4,1.8a.4.4,0,0,1-.24-.71C.566.776.967.444,1.349.1a.4.4,0,0,1,.528.588c-.4.356-.815.7-1.242,1.027A.393.393,0,0,1,.4,1.8Z",
    transform: "translate(31.775 17.934)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3686",
    "data-name": "Path 3686",
    d: "M19.679,17.193h-.005a20.137,20.137,0,0,1-3.14-.287.395.395,0,1,1,.133-.778,19.413,19.413,0,0,0,3.016.275.4.4,0,0,1,0,.79Zm4.981-.577a.4.4,0,0,1-.095-.779,19.662,19.662,0,0,0,2.5-.8c.127-.05.254-.1.378-.154a.4.4,0,0,1,.306.729c-.13.055-.261.108-.393.16a20.527,20.527,0,0,1-2.6.833A.411.411,0,0,1,24.66,16.616ZM11.8,15.452a.391.391,0,0,1-.161-.035,20.306,20.306,0,0,1-2.767-1.51.4.4,0,1,1,.431-.662A19.52,19.52,0,0,0,11.965,14.7a.395.395,0,0,1-.162.755ZM5.27,10.727a.4.4,0,0,1-.292-.129A20.084,20.084,0,0,1,3.044,8.109a.4.4,0,0,1,.66-.435,19.348,19.348,0,0,0,1.858,2.391.4.4,0,0,1-.292.661Zm-4.1-6.943a.4.4,0,0,1-.373-.267A20.308,20.308,0,0,1,.006.464.4.4,0,0,1,.784.327a19.564,19.564,0,0,0,.757,2.933.4.4,0,0,1-.246.5A.4.4,0,0,1,1.167,3.784Z",
    transform: "translate(0.232 6.596)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3687",
    "data-name": "Path 3687",
    d: "M.4,2.358H.363A.4.4,0,0,1,0,1.93C.045,1.4.111.861.2.331a.4.4,0,0,1,.78.127C.894.968.831,1.485.789,2A.4.4,0,0,1,.4,2.358Z",
    transform: "translate(0 0)",
    fill: "#d7d6e2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11884",
    "data-name": "Group 11884",
    transform: "translate(7.814 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3688",
    "data-name": "Path 3688",
    d: "M.4,1.69A.4.4,0,0,1,.157.979C.585.658,1.03.349,1.482.061a.4.4,0,1,1,.424.668C1.471,1,1.043,1.3.633,1.611A.393.393,0,0,1,.4,1.69Z",
    transform: "translate(0 3.028)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3689",
    "data-name": "Path 3689",
    d: "M26.249,18.113a.4.4,0,0,1-.391-.347,19.37,19.37,0,0,0-.594-2.919.4.4,0,0,1,.76-.217,20.181,20.181,0,0,1,.617,3.039.4.4,0,0,1-.343.441A.349.349,0,0,1,26.249,18.113Zm-2.528-7.521a.394.394,0,0,1-.342-.2A19.48,19.48,0,0,0,21.693,7.94a.4.4,0,1,1,.615-.5A20.2,20.2,0,0,1,24.062,10a.395.395,0,0,1-.341.593ZM18.448,4.668a.39.39,0,0,1-.236-.079A19.561,19.561,0,0,0,15.7,3a.395.395,0,1,1,.37-.7,20.373,20.373,0,0,1,2.618,1.659.4.4,0,0,1-.237.712ZM.4,1.711A.4.4,0,0,1,.272.94,20.223,20.223,0,0,1,3.282.2a.395.395,0,1,1,.13.779,19.5,19.5,0,0,0-2.893.714A.4.4,0,0,1,.4,1.711Zm10.879-.426a.386.386,0,0,1-.094-.011A19.48,19.48,0,0,0,8.24.789.4.4,0,0,1,7.881.362.392.392,0,0,1,8.309,0a20.257,20.257,0,0,1,3.059.5.4.4,0,0,1-.093.779Z",
    transform: "translate(5.76 0)",
    fill: "#d7d6e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3690",
    "data-name": "Path 3690",
    d: "M.4,2.347a.418.418,0,0,1-.082-.008.4.4,0,0,1-.3-.468C.115,1.365.2.851.268.344a.4.4,0,1,1,.784.1C.984.973.893,1.508.782,2.033A.4.4,0,0,1,.4,2.347Z",
    transform: "translate(31.336 22.273)",
    fill: "#d7d6e2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3691",
    "data-name": "Path 3691",
    d: "M9.508,19.027A9.505,9.505,0,1,1,19,10.228c0,.027,0,.055-.006.083l-1.181-.1q.029-.341.029-.684a8.4,8.4,0,0,0-.071-1.089,8.327,8.327,0,0,0-14.856-4A8.266,8.266,0,0,0,1.185,9.5,8.33,8.33,0,0,0,14.676,16.05l.736.929a9.535,9.535,0,0,1-5.9,2.048Z",
    transform: "translate(10.575 10.589)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26629",
    "data-name": "Group 26629",
    transform: "translate(1524.027 1701.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11887",
    "data-name": "Group 11887",
    transform: "translate(10.885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3696",
    "data-name": "Path 3696",
    d: "M306.769,105.832s-20.911,10.762-30.681-.764c-7.852-9.264,5.713-2.526,18.661-.656a.8.8,0,0,0,.3-1.58c-9.829-2.27-24.5-6.613-25.146-12.425-.982-8.775,1.754-5.022,12.756.318s14.254,3.349,7.47-1.2-20.078-5.105-21.483-9.746-.229-12.364-.173-15.855,17.079-2.376,19.7,3.216,2.593,15.871,6.881,19.358,2-6.472.294-11.811-1.851-8.883,4.281-5.463,6.593,12.642,5.058,18.821-.488,10.35.507,7.381,3.3-12.352,2.236-15.833S319.953,84.975,306.769,105.832Z",
    transform: "translate(-267.954 -61.937)",
    fill: "#396"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11888",
    "data-name": "Group 11888",
    transform: "translate(0 31.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3697",
    "data-name": "Path 3697",
    d: "M273.683,196.983s-7.064,17.647-19.135,15.786c-9.7-1.5,2.149-4.568,11.044-10.286a.65.65,0,0,0-.656-1.122c-7.2,3.821-18.457,8.939-21.933,5.736-5.248-4.837-1.59-4,7.955-6.563s10.476-5.506,3.927-4.687-14.961,7.519-18.278,5.431-6.689-7.427-8.5-9.587,9.167-10.5,13.728-8.471,9.99,8.316,14.455,8.172-2.205-5.012-6.077-7.366-5.836-4.442-.281-5.6,10.722,4.225,13.058,8.81,5.185,6.577,4.22,4.238-4.528-9.289-7.022-10.85S270.683,177.267,273.683,196.983Z",
    transform: "translate(-227.903 -178.264)",
    fill: "#9c3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26636",
    "data-name": "Group 26636",
    transform: "translate(1674.415 1750.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8378",
    "data-name": "Path 8378",
    d: "M967.2,413.688a15.575,15.575,0,1,0-31.05-2.5v0a16.68,16.68,0,0,1-6.62,12.007,19.816,19.816,0,0,0-7.888,14.3v0a18.625,18.625,0,0,1-8.445,14.137,22.557,22.557,0,1,0,34.734,20.749q.08-1,.073-1.977a23.269,23.269,0,0,1,7.187-16.967,19.9,19.9,0,0,0,5.536-19.189,13.04,13.04,0,0,1,2.765-11.674A15.5,15.5,0,0,0,967.2,413.688Z",
    transform: "translate(-864.631 -366.563)",
    fill: "#396"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8381",
    "data-name": "Path 8381",
    d: "M947.258,518.472a.315.315,0,0,1-.258-.494c25.386-36.673,35.245-70.655,35.341-70.994a.315.315,0,0,1,.605.173c-.1.34-9.984,34.422-35.429,71.179A.315.315,0,0,1,947.258,518.472Z",
    transform: "translate(-894.829 -400.761)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8382",
    "data-name": "Path 8382",
    d: "M1032.223,461.926a.312.312,0,0,1-.207-.077c-3.567-3.1-5.437-12.863-5.515-13.277a.314.314,0,0,1,.618-.116c.019.1,1.907,9.958,5.309,12.919a.314.314,0,0,1-.206.552Z",
    transform: "translate(-949.359 -401.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8383",
    "data-name": "Path 8383",
    d: "M1044.988,478.626a.314.314,0,0,1-.083-.618c.065-.018,6.552-1.831,10.575-5.4a.315.315,0,0,1,.418.471c-4.134,3.671-10.554,5.464-10.826,5.539A.319.319,0,0,1,1044.988,478.626Z",
    transform: "translate(-961.82 -418.427)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8384",
    "data-name": "Path 8384",
    d: "M1001.873,524.975a.312.312,0,0,1-.243-.115c-4.835-5.876-5.551-15.609-5.558-15.707a.315.315,0,1,1,.628-.043c.007.1.71,9.631,5.415,15.35a.315.315,0,0,1-.242.514Z",
    transform: "translate(-928.505 -443.303)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8385",
    "data-name": "Path 8385",
    d: "M1014.557,546.733c-.2,0-.314-.006-.347-.008a.314.314,0,1,1,.036-.628c.069,0,7.036.321,14.432-5.723a.315.315,0,0,1,.4.487C1022.337,546.369,1016.088,546.733,1014.557,546.733Z",
    transform: "translate(-940.735 -464.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8393",
    "data-name": "Path 8393",
    d: "M971.557,630.492c-.6,0-.953-.026-.969-.027a.315.315,0,0,1,.05-.627,25.975,25.975,0,0,0,15.231-4.271.314.314,0,1,1,.36.516A26.554,26.554,0,0,1,971.557,630.492Z",
    transform: "translate(-910.837 -523.295)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8390",
    "data-name": "Path 8390",
    d: "M958.366,607.113a.314.314,0,0,1-.226-.1c-.205-.212-5.037-5.3-5.328-15.09a.314.314,0,1,1,.628-.019c.284,9.533,5.1,14.621,5.151,14.67a.315.315,0,0,1-.226.534Z",
    transform: "translate(-898.852 -500.053)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8379",
    "data-name": "Path 8379",
    d: "M829.875,306.549a19.956,19.956,0,1,1,28.578,27.863v0a21.372,21.372,0,0,0-6.009,16.509,25.39,25.39,0,0,1-7.157,19.668v0a23.863,23.863,0,0,0-6.528,20.064,28.9,28.9,0,1,1-49.3-16.036q.894-.917,1.847-1.737a29.814,29.814,0,0,0,10.318-21.236,25.491,25.491,0,0,1,13.854-21.515,16.708,16.708,0,0,0,8.936-12.508A19.864,19.864,0,0,1,829.875,306.549Z",
    transform: "translate(-781.25 -300.524)",
    fill: "#9c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8386",
    "data-name": "Path 8386",
    d: "M853.891,456.46a.331.331,0,0,1-.078-.009.315.315,0,0,1-.228-.382c14.028-55.522,38.582-93.776,38.828-94.156a.314.314,0,0,1,.528.342c-.246.379-24.745,38.552-38.746,93.968A.315.315,0,0,1,853.891,456.46Z",
    transform: "translate(-830.828 -342.506)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8380",
    "data-name": "Path 8380",
    d: "M949.989,401.3a8.33,8.33,0,0,1-1.137-.074.314.314,0,1,1,.086-.623c5.755.79,16.889-5.708,17-5.774a.315.315,0,0,1,.319.542,67.9,67.9,0,0,1-6.411,3.231C955.744,400.4,952.436,401.3,949.989,401.3Z",
    transform: "translate(-895.95 -365.14)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8387",
    "data-name": "Path 8387",
    d: "M939.855,380.479a.315.315,0,0,1-.283-.178c-.038-.079-3.828-8.015-3.769-15.077a.314.314,0,0,1,.315-.312h0a.315.315,0,0,1,.312.317c-.058,6.917,3.668,14.72,3.706,14.8a.314.314,0,0,1-.283.451Z",
    transform: "translate(-887.191 -344.661)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8388",
    "data-name": "Path 8388",
    d: "M908.373,483.661a.315.315,0,0,1-.009-.629c9.514-.279,19.332-7.653,19.43-7.728a.314.314,0,1,1,.381.5c-.1.076-10.074,7.571-19.792,7.856Z",
    transform: "translate(-868.174 -420.287)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8389",
    "data-name": "Path 8389",
    d: "M892.8,459.253a.312.312,0,0,1-.224-.094c-.064-.065-6.435-6.7-6.845-19.231a.314.314,0,0,1,.3-.324h.01a.314.314,0,0,1,.314.3,33.183,33.183,0,0,0,3.483,14.059,21.227,21.227,0,0,0,3.182,4.752.315.315,0,0,1-.225.535Z",
    transform: "translate(-852.87 -395.859)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8391",
    "data-name": "Path 8391",
    d: "M847.295,570.268a.314.314,0,0,1-.22-.089c-.077-.075-7.718-7.64-8.926-18.735a.315.315,0,0,1,.626-.068c1.184,10.873,8.664,18.279,8.74,18.352a.315.315,0,0,1-.22.54Z",
    transform: "translate(-820.251 -472.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8392",
    "data-name": "Path 8392",
    d: "M867.828,594.878c-.163,0-.253,0-.261,0a.315.315,0,0,1,.033-.629c.089.006,9.091.373,18.561-7.413a.315.315,0,0,1,.4.486C877.8,594.52,869.4,594.878,867.828,594.878Z",
    transform: "translate(-840.213 -496.734)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26634",
    "data-name": "Group 26634",
    transform: "translate(3.206 91.727)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26632",
    "data-name": "Group 26632",
    transform: "translate(0 19.646)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3667",
    "data-name": "Path 3667",
    d: "M800.178,685.617h90.074V667.589H800.178C802.106,667.589,802.106,685.617,800.178,685.617Z",
    transform: "translate(-797.432 -663.512)",
    fill: "#eeeef2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3668",
    "data-name": "Path 3668",
    d: "M884.265,672.221v-8.251c0-2.908-1.78-5.266-3.975-5.266H794.572a3.127,3.127,0,0,1-3.127-3.127h0a.95.95,0,0,1,.95-.95h93.683c2.149,0,5.56,3.378,5.56,7.545V673.7c0,3.929-3.312,7.114-5.337,7.114H792.888a1.443,1.443,0,0,1-1.443-1.443h0a2.634,2.634,0,0,1,2.634-2.634H880.86C882.741,676.733,884.265,674.713,884.265,672.221Z",
    transform: "translate(-791.445 -654.628)",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3669",
    "data-name": "Path 3669",
    d: "M893.866,678.979H809.41a.315.315,0,0,1,0-.629h84.456a.315.315,0,0,1,0,.629Z",
    transform: "translate(-803.544 -670.889)",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3670",
    "data-name": "Path 3670",
    d: "M893.866,687.486H809.41a.315.315,0,0,1,0-.629h84.456a.315.315,0,1,1,0,.629Z",
    transform: "translate(-803.544 -676.72)",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3671",
    "data-name": "Path 3671",
    d: "M893.866,695.994H809.41a.315.315,0,0,1,0-.629h84.456a.315.315,0,1,1,0,.629Z",
    transform: "translate(-803.544 -682.552)",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3672",
    "data-name": "Path 3672",
    d: "M893.866,704.5H809.41a.314.314,0,1,1,0-.629h84.456a.314.314,0,1,1,0,.629Z",
    transform: "translate(-803.544 -688.385)",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3673",
    "data-name": "Path 3673",
    d: "M893.866,713.01H809.41a.314.314,0,1,1,0-.629h84.456a.314.314,0,1,1,0,.629Z",
    transform: "translate(-803.544 -694.217)",
    fill: "#f93"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11877",
    "data-name": "Group 11877",
    transform: "translate(11.644)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7986",
    "data-name": "Rectangle 7986",
    width: 81.049,
    height: 19.564,
    rx: 9.782,
    transform: "translate(81.049 19.564) rotate(180)",
    fill: "#afd75f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7987",
    "data-name": "Rectangle 7987",
    width: 9.521,
    height: 15.067,
    rx: 4.761,
    transform: "translate(71.889 17.315) rotate(180)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7988",
    "data-name": "Rectangle 7988",
    width: 3.573,
    height: 15.067,
    rx: 1.786,
    transform: "translate(60.967 17.315) rotate(180)",
    fill: "#fff",
    opacity: 0.6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26635",
    "data-name": "Group 26635",
    transform: "translate(0.824 85.726)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11927",
    "data-name": "Group 11927",
    transform: "translate(20.421 21.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3895",
    "data-name": "Path 3895",
    d: "M848.914,664.257s11,15.907,22.553,11.33c9.285-3.678-3.166-4.045-13.283-7.7a.662.662,0,0,1,.4-1.261c8.009,2.161,20.331,4.691,23.055.727,4.111-5.985.673-4.323-9.377-4.711s-11.637-3.092-4.956-3.761,16.542,4.073,19.359,1.251,4.955-8.881,6.267-11.434-11.469-8.339-15.534-5.3-8.029,10.509-12.49,11.377,1.054-5.471,4.362-8.682,4.784-5.727-.989-5.622-9.68,6.617-10.959,11.694-3.655,7.7-3.227,5.158,2.39-10.239,4.51-12.352S847.429,644.02,848.914,664.257Z",
    transform: "translate(-848.798 -640.469)",
    fill: "#396"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3896",
    "data-name": "Path 3896",
    d: "M852.249,688.264a.17.17,0,0,0,.176-.008c12.337-8.208,31.812-12.783,32.007-12.828a.171.171,0,0,0-.077-.333c-.2.045-19.73,4.633-32.12,12.877a.171.171,0,0,0-.047.237A.168.168,0,0,0,852.249,688.264Z",
    transform: "translate(-851.102 -664.201)",
    fill: "#fff",
    opacity: 0.53
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11928",
    "data-name": "Group 11928",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3897",
    "data-name": "Path 3897",
    d: "M795.43,626.105s23.421,3.892,29.256-10.2c4.689-11.328-6.27-.665-18.14,5.129a.812.812,0,0,1-.773-1.428c8.747-5.215,21.505-13.916,20.337-19.7-1.764-8.738-3.236-4.286-12.163,4.242s-12.668,7.618-7.549,1.156,17.723-11.1,17.642-16-3.6-11.955-4.727-15.293-17.149,2.987-17.941,9.17,2.406,16.056-.64,20.731-3.923-5.6-3.928-11.262-.962-9.11-5.8-3.93-2.436,14.187.947,19.652,3.663,9.8,1.791,7.252-6.985-10.855-7.036-14.529S776.32,610.127,795.43,626.105Z",
    transform: "translate(-783.87 -573.082)",
    fill: "#82ad2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3898",
    "data-name": "Path 3898",
    d: "M823.6,653.093a.208.208,0,0,0,.143-.162c3.3-17.889,15.908-38.966,16.035-39.176a.209.209,0,1,0-.359-.216c-.128.211-12.771,21.352-16.088,39.316a.21.21,0,0,0,.269.238Z",
    transform: "translate(-810.915 -600.745)",
    fill: "#fff",
    opacity: 0.53
  })))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1590",
    "data-name": "Ellipse 1590",
    cx: 18.76,
    cy: 18.76,
    r: 18.76,
    transform: "translate(1565.656 1744.104)",
    fill: "#eeeef2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26603",
    "data-name": "Group 26603",
    transform: "translate(1561.914 1730.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8292",
    "data-name": "Path 8292",
    d: "M547.184,550.132a3.351,3.351,0,0,1,3.783-3.362c13.407,1.747,59.506,7.126,97.581,4a3.1,3.1,0,0,1,3.352,2.905l8.337,142.831a3.566,3.566,0,0,1-3.331,3.767c-16.015,1.031-81.971,5.04-105.517,2.7a2.825,2.825,0,0,1-2.542-2.783Z",
    transform: "translate(-547.184 -546.742)",
    fill: "#0c1b24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8293",
    "data-name": "Path 8293",
    d: "M569.62,601.992a3.225,3.225,0,0,1,3.641-3.235c12.9,1.681,57.265,6.858,93.906,3.854a2.982,2.982,0,0,1,3.226,2.8l8.023,137.452a3.432,3.432,0,0,1-3.205,3.626c-15.412.993-78.885,4.85-101.543,2.6a2.719,2.719,0,0,1-2.447-2.678Z",
    transform: "translate(-568.023 -595.029)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8294",
    "data-name": "Path 8294",
    d: "M738.073,765.312l1.523,29.469a1.874,1.874,0,0,0,1.828,1.778c5.46.126,22.473.452,32.075-.1a2.093,2.093,0,0,0,1.971-2.033c.155-5.529.471-21.621-.823-28.34a2.361,2.361,0,0,0-2.252-1.909l-32.273-.961A1.992,1.992,0,0,0,738.073,765.312Z",
    transform: "translate(-724.485 -747.811)",
    fill: "#fff",
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1657",
    "data-name": "Ellipse 1657",
    cx: 6.337,
    cy: 6.337,
    rx: 6.337,
    ry: 6.337,
    transform: "translate(25.821 34.227) rotate(-89.528)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8295",
    "data-name": "Path 8295",
    d: "M844.432,1085.13l20.187-.1a1.563,1.563,0,0,0,1.3-2.416,13.028,13.028,0,0,0-11.549-6.387,14.073,14.073,0,0,0-11.289,6.345A1.633,1.633,0,0,0,844.432,1085.13Z",
    transform: "translate(-821.751 -1038.533)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26591",
    "data-name": "Group 26591",
    transform: "translate(58.048 17.202)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8296",
    "data-name": "Path 8296",
    d: "M1399.137,790.908a1.044,1.044,0,0,0,1.115-.995,1.144,1.144,0,0,0-1.183-1l-35.387-.446a.747.747,0,0,0-.762,1.068l.172.48a1.743,1.743,0,0,0,1.537,1.076Z",
    transform: "translate(-1362.858 -788.464)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26592",
    "data-name": "Group 26592",
    transform: "translate(58.077 22.697)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8297",
    "data-name": "Path 8297",
    d: "M1364.085,865.68a.747.747,0,0,0-.762,1.068l.172.48a1.744,1.744,0,0,0,1.537,1.076l34.508-.18a1.044,1.044,0,0,0,1.115-.995,1.145,1.145,0,0,0-1.183-1Z",
    transform: "translate(-1363.26 -865.68)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26593",
    "data-name": "Group 26593",
    transform: "translate(58.106 28.272)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8298",
    "data-name": "Path 8298",
    d: "M1364.492,944.018a.747.747,0,0,0-.762,1.068l.172.48a1.744,1.744,0,0,0,1.537,1.076l34.508-.18a1.044,1.044,0,0,0,1.115-.995,1.145,1.145,0,0,0-1.183-1Z",
    transform: "translate(-1363.667 -944.018)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26594",
    "data-name": "Group 26594",
    transform: "translate(14.289 55.376)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8299",
    "data-name": "Path 8299",
    d: "M831.647,1327.082a1,1,0,0,0,1.079-.995,1.183,1.183,0,0,0-1.22-.991l-82.9-.222c-.632,0-.825.4-.429.893l.682.847a2.708,2.708,0,0,0,1.87.89Z",
    transform: "translate(-747.975 -1324.874)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26595",
    "data-name": "Group 26595",
    transform: "translate(14.318 60.872)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8300",
    "data-name": "Path 8300",
    d: "M749.011,1402.09c-.632,0-.825.4-.429.892l.682.847a2.708,2.708,0,0,0,1.87.89l80.915-.421a1,1,0,0,0,1.079-.995,1.183,1.183,0,0,0-1.22-.992Z",
    transform: "translate(-748.376 -1402.09)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8301",
    "data-name": "Path 8301",
    d: "M736.839,1527.215c1.992-.163,5.724-.254,7.779-.293a1.862,1.862,0,0,1,1.846,1.415,30.356,30.356,0,0,1,.914,7.518,1.653,1.653,0,0,1-1.66,1.627l-7.582-.042a1.82,1.82,0,0,1-1.8-1.642l-.7-7.129A1.327,1.327,0,0,1,736.839,1527.215Z",
    transform: "translate(-722.213 -1457.167)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26596",
    "data-name": "Group 26596",
    transform: "translate(27.677 72.904)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8302",
    "data-name": "Path 8302",
    d: "M937.076,1571.16a.915.915,0,0,0-.972,1.094l.19,1.222a1.381,1.381,0,0,0,1.326,1.13l18.413-.1a1.136,1.136,0,0,0,1.129-1.155l-.005-.311a1.231,1.231,0,0,0-1.169-1.191Z",
    transform: "translate(-936.09 -1571.159)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8303",
    "data-name": "Path 8303",
    d: "M1317.234,1524.195c1.992-.163,5.724-.253,7.779-.293a1.862,1.862,0,0,1,1.845,1.414,30.34,30.34,0,0,1,.914,7.518,1.653,1.653,0,0,1-1.66,1.628l-7.582-.042a1.821,1.821,0,0,1-1.8-1.642l-.7-7.129A1.327,1.327,0,0,1,1317.234,1524.195Z",
    transform: "translate(-1261.303 -1454.362)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26597",
    "data-name": "Group 26597",
    transform: "translate(68.981 72.689)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8304",
    "data-name": "Path 8304",
    d: "M1517.47,1568.14a.915.915,0,0,0-.972,1.094l.19,1.221a1.38,1.38,0,0,0,1.326,1.13l18.413-.1a1.136,1.136,0,0,0,1.13-1.155l-.006-.311a1.231,1.231,0,0,0-1.169-1.191Z",
    transform: "translate(-1516.484 -1568.139)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26602",
    "data-name": "Group 26602",
    transform: "translate(15.875 88.713)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8305",
    "data-name": "Path 8305",
    d: "M779.85,1802.894h-.019l-7-.031a1.88,1.88,0,0,1-1.928-1.589l-.646-5.867a1.274,1.274,0,0,1,.3-.961,1.535,1.535,0,0,1,1.068-.534h0c.589-.043,1.419-.118,2.3-.2,1.849-.167,4.151-.375,5.447-.4a1.955,1.955,0,0,1,1.966,1.36,29.334,29.334,0,0,1,.3,6.614A1.729,1.729,0,0,1,779.85,1802.894Zm-8.185-8.446a1,1,0,0,0-.694.341.744.744,0,0,0-.175.558l.645,5.867a1.347,1.347,0,0,0,1.4,1.111l7,.031h.014a1.192,1.192,0,0,0,1.249-1.077,29.211,29.211,0,0,0-.278-6.461,1.444,1.444,0,0,0-1.439-.966c-1.276.023-3.567.23-5.408.4-.881.08-1.713.155-2.306.2Z",
    transform: "translate(-770.253 -1793.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8306",
    "data-name": "Path 8306",
    d: "M788.99,1811.467c1.469-.108,4.662-.449,6.177-.476a1.354,1.354,0,0,1,1.36.929,23.782,23.782,0,0,1,.23,5.224,1.164,1.164,0,0,1-1.225,1.071l-5.591-.025a1.292,1.292,0,0,1-1.328-1.079l-.516-4.688A.908.908,0,0,1,788.99,1811.467Z",
    transform: "translate(-786.823 -1809.733)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26598",
    "data-name": "Group 26598",
    transform: "translate(15.66 3.418)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8307",
    "data-name": "Path 8307",
    d: "M990.365,1843.569a1.737,1.737,0,0,0,1.7,1.285l64.728-.889a1.314,1.314,0,0,0-.019-2.627l-64.734.042A1.737,1.737,0,0,0,990.365,1843.569Z",
    transform: "translate(-990.305 -1841.338)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8308",
    "data-name": "Path 8308",
    d: "M780.946,2013.586h-.019l-7-.031a1.881,1.881,0,0,1-1.928-1.59l-.645-5.867a1.275,1.275,0,0,1,.3-.961,1.537,1.537,0,0,1,1.068-.534h0c.589-.043,1.419-.118,2.3-.2,1.849-.167,4.151-.375,5.447-.4h.028a1.952,1.952,0,0,1,1.938,1.36,29.343,29.343,0,0,1,.3,6.614A1.729,1.729,0,0,1,780.946,2013.586Zm-8.185-8.446a.994.994,0,0,0-.694.341.742.742,0,0,0-.176.558l.646,5.866a1.346,1.346,0,0,0,1.4,1.111l7,.031h.014a1.192,1.192,0,0,0,1.249-1.077,29.21,29.21,0,0,0-.278-6.461,1.436,1.436,0,0,0-1.439-.966c-1.276.023-3.567.23-5.408.4-.881.08-1.713.155-2.306.2Z",
    transform: "translate(-771.272 -1989.014)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8309",
    "data-name": "Path 8309",
    d: "M790.086,2022.163c1.469-.108,4.662-.449,6.177-.475a1.355,1.355,0,0,1,1.361.929,23.772,23.772,0,0,1,.23,5.224,1.164,1.164,0,0,1-1.225,1.071l-5.591-.025a1.292,1.292,0,0,1-1.328-1.079l-.516-4.688A.908.908,0,0,1,790.086,2022.163Z",
    transform: "translate(-787.842 -2005.435)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26599",
    "data-name": "Group 26599",
    transform: "translate(15.738 18.412)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8310",
    "data-name": "Path 8310",
    d: "M991.461,2054.266a1.737,1.737,0,0,0,1.7,1.285l64.728-.889a1.314,1.314,0,0,0-.019-2.627l-64.734.041A1.737,1.737,0,0,0,991.461,2054.266Z",
    transform: "translate(-991.401 -2052.035)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8311",
    "data-name": "Path 8311",
    d: "M782.042,2224.282h-.019l-7-.031a1.88,1.88,0,0,1-1.928-1.589l-.646-5.867a1.277,1.277,0,0,1,.3-.961,1.539,1.539,0,0,1,1.068-.534h0c.589-.043,1.419-.118,2.3-.2,1.85-.167,4.151-.375,5.447-.4h.028a1.951,1.951,0,0,1,1.938,1.361,29.325,29.325,0,0,1,.3,6.613A1.729,1.729,0,0,1,782.042,2224.282Zm-8.185-8.446a1,1,0,0,0-.694.341.742.742,0,0,0-.175.559l.645,5.867a1.345,1.345,0,0,0,1.4,1.111l7,.031h.014a1.191,1.191,0,0,0,1.249-1.077,29.2,29.2,0,0,0-.278-6.46,1.433,1.433,0,0,0-1.439-.966c-1.276.023-3.567.23-5.408.4-.881.08-1.713.155-2.306.2Z",
    transform: "translate(-772.29 -2184.716)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8312",
    "data-name": "Path 8312",
    d: "M791.183,2232.861c1.469-.109,4.662-.449,6.177-.476a1.354,1.354,0,0,1,1.36.929,23.783,23.783,0,0,1,.23,5.224,1.164,1.164,0,0,1-1.225,1.071l-5.591-.024a1.292,1.292,0,0,1-1.328-1.079l-.516-4.688A.908.908,0,0,1,791.183,2232.861Z",
    transform: "translate(-788.86 -2201.138)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26600",
    "data-name": "Group 26600",
    transform: "translate(15.816 33.406)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8313",
    "data-name": "Path 8313",
    d: "M992.558,2264.962a1.736,1.736,0,0,0,1.7,1.286l64.728-.889a1.314,1.314,0,0,0-.019-2.627l-64.734.042A1.737,1.737,0,0,0,992.558,2264.962Z",
    transform: "translate(-992.497 -2262.732)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8314",
    "data-name": "Path 8314",
    d: "M783.139,2434.98h-.019l-7-.031a1.88,1.88,0,0,1-1.928-1.589l-.646-5.866a1.279,1.279,0,0,1,.3-.962,1.535,1.535,0,0,1,1.068-.534h0c.589-.043,1.419-.118,2.3-.2,1.849-.167,4.151-.375,5.447-.4h.028a1.951,1.951,0,0,1,1.938,1.36,29.348,29.348,0,0,1,.3,6.614A1.729,1.729,0,0,1,783.139,2434.98Zm-8.185-8.445a1,1,0,0,0-.694.341.744.744,0,0,0-.175.559l.646,5.866a1.345,1.345,0,0,0,1.4,1.111l7,.031h.014a1.192,1.192,0,0,0,1.249-1.077,29.213,29.213,0,0,0-.278-6.46,1.433,1.433,0,0,0-1.439-.966c-1.276.023-3.567.23-5.408.4-.881.079-1.713.154-2.306.2Z",
    transform: "translate(-773.308 -2380.419)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8315",
    "data-name": "Path 8315",
    d: "M792.279,2443.558c1.469-.108,4.662-.449,6.177-.476a1.356,1.356,0,0,1,1.36.93,23.77,23.77,0,0,1,.23,5.224,1.164,1.164,0,0,1-1.225,1.071l-5.591-.025a1.292,1.292,0,0,1-1.328-1.079l-.516-4.688A.908.908,0,0,1,792.279,2443.558Z",
    transform: "translate(-789.878 -2396.84)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26601",
    "data-name": "Group 26601",
    transform: "translate(15.894 48.401)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8316",
    "data-name": "Path 8316",
    d: "M993.654,2475.659h0a1.738,1.738,0,0,0,1.7,1.286l64.728-.889a1.314,1.314,0,0,0-.019-2.627l-64.734.042A1.737,1.737,0,0,0,993.654,2475.659Z",
    transform: "translate(-993.593 -2473.429)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8317",
    "data-name": "Path 8317",
    d: "M801.076,2396.984h0a1.074,1.074,0,0,1,1.483.4l1.393,2.467a.345.345,0,0,0,.616-.03l3.383-7.638a.382.382,0,0,1,.732.161,15.044,15.044,0,0,1-4.323,10.492s-2.056-.787-3.728-4.407A1.127,1.127,0,0,1,801.076,2396.984Z",
    transform: "translate(-798.372 -2349.348)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_8318",
    "data-name": "Path 8318",
    d: "M665.948,675.146a3.351,3.351,0,0,1,3.783-3.362c13.407,1.747,59.506,7.126,97.581,4a3.1,3.1,0,0,1,3.352,2.905L779,821.524a3.566,3.566,0,0,1-3.331,3.767c-16.015,1.031-81.971,5.04-105.516,2.7a2.825,2.825,0,0,1-2.543-2.783Z",
    transform: "translate(904.418 1067.572)",
    fill: "#0c1b24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8319",
    "data-name": "Path 8319",
    d: "M688.385,727.006a3.225,3.225,0,0,1,3.641-3.235c12.9,1.681,57.265,6.858,93.906,3.853a2.982,2.982,0,0,1,3.226,2.8l8.023,137.452a3.432,3.432,0,0,1-3.205,3.626c-15.412.993-78.885,4.85-101.543,2.6a2.719,2.719,0,0,1-2.447-2.678Z",
    transform: "translate(883.578 1019.284)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8320",
    "data-name": "Path 8320",
    d: "M856.837,890.326l1.523,29.469a1.873,1.873,0,0,0,1.828,1.778c5.46.126,22.473.452,32.075-.1a2.093,2.093,0,0,0,1.971-2.033c.154-5.529.472-21.621-.823-28.34a2.362,2.362,0,0,0-2.252-1.91l-32.273-.96A1.993,1.993,0,0,0,856.837,890.326Z",
    transform: "translate(727.117 866.502)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1658",
    "data-name": "Ellipse 1658",
    cx: 6.337,
    cy: 6.337,
    rx: 6.337,
    ry: 6.337,
    transform: "translate(1594.79 1771.707) rotate(-74.683)",
    fill: "#396"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8321",
    "data-name": "Path 8321",
    d: "M963.2,1210.144l20.188-.105a1.563,1.563,0,0,0,1.3-2.416,13.028,13.028,0,0,0-11.549-6.387,14.074,14.074,0,0,0-11.289,6.344A1.634,1.634,0,0,0,963.2,1210.144Z",
    transform: "translate(629.85 575.78)",
    fill: "#396"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26604",
    "data-name": "Group 26604",
    transform: "translate(1628.414 1756.529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8322",
    "data-name": "Path 8322",
    d: "M1517.9,915.922a1.044,1.044,0,0,0,1.116-.995,1.145,1.145,0,0,0-1.184-1l-35.386-.446a.747.747,0,0,0-.762,1.068l.172.48a1.742,1.742,0,0,0,1.537,1.076Z",
    transform: "translate(-1481.621 -913.478)",
    fill: "#eeeef2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26605",
    "data-name": "Group 26605",
    transform: "translate(1628.443 1762.023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8323",
    "data-name": "Path 8323",
    d: "M1482.849,990.694a.747.747,0,0,0-.762,1.068l.172.48a1.743,1.743,0,0,0,1.537,1.076l34.507-.18a1.044,1.044,0,0,0,1.116-.995,1.145,1.145,0,0,0-1.184-1Z",
    transform: "translate(-1482.024 -990.694)",
    fill: "#eeeef2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26606",
    "data-name": "Group 26606",
    transform: "translate(1628.472 1767.599)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8324",
    "data-name": "Path 8324",
    d: "M1483.257,1069.032a.747.747,0,0,0-.762,1.068l.172.48a1.744,1.744,0,0,0,1.537,1.076l34.507-.18a1.045,1.045,0,0,0,1.116-.995,1.144,1.144,0,0,0-1.183-1Z",
    transform: "translate(-1482.432 -1069.032)",
    fill: "#eeeef2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26607",
    "data-name": "Group 26607",
    transform: "translate(1584.656 1794.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8325",
    "data-name": "Path 8325",
    d: "M950.411,1452.1a1,1,0,0,0,1.079-.995,1.183,1.183,0,0,0-1.22-.992l-82.9-.222c-.632,0-.825.4-.429.893l.682.847a2.707,2.707,0,0,0,1.87.89Z",
    transform: "translate(-866.739 -1449.888)",
    fill: "#eeeef2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26608",
    "data-name": "Group 26608",
    transform: "translate(1584.684 1800.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8326",
    "data-name": "Path 8326",
    d: "M867.775,1527.1c-.632,0-.825.4-.429.892l.682.847a2.707,2.707,0,0,0,1.87.89l80.915-.421a1,1,0,0,0,1.079-.995,1.183,1.183,0,0,0-1.22-.991Z",
    transform: "translate(-867.141 -1527.104)",
    fill: "#eeeef2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8327",
    "data-name": "Path 8327",
    d: "M855.6,1652.229c1.992-.163,5.724-.253,7.779-.293a1.862,1.862,0,0,1,1.846,1.415,30.336,30.336,0,0,1,.914,7.518,1.653,1.653,0,0,1-1.66,1.627l-7.582-.042a1.821,1.821,0,0,1-1.8-1.642l-.7-7.129A1.326,1.326,0,0,1,855.6,1652.229Z",
    transform: "translate(729.388 157.145)",
    fill: "#eeeef2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26609",
    "data-name": "Group 26609",
    transform: "translate(1598.043 1812.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8328",
    "data-name": "Path 8328",
    d: "M1055.84,1696.173a.915.915,0,0,0-.972,1.094l.19,1.221a1.38,1.38,0,0,0,1.326,1.13l18.413-.1a1.136,1.136,0,0,0,1.129-1.156l-.005-.311a1.231,1.231,0,0,0-1.169-1.191Z",
    transform: "translate(-1054.854 -1696.173)",
    fill: "#eeeef2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8329",
    "data-name": "Path 8329",
    d: "M1436,1649.209c1.992-.163,5.724-.253,7.779-.293a1.862,1.862,0,0,1,1.846,1.414,30.345,30.345,0,0,1,.914,7.518,1.654,1.654,0,0,1-1.66,1.628l-7.582-.042a1.821,1.821,0,0,1-1.8-1.642l-.7-7.129A1.327,1.327,0,0,1,1436,1649.209Z",
    transform: "translate(190.298 159.951)",
    fill: "#eeeef2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26610",
    "data-name": "Group 26610",
    transform: "translate(1639.347 1812.015)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8330",
    "data-name": "Path 8330",
    d: "M1636.234,1693.153a.915.915,0,0,0-.972,1.094l.19,1.222a1.381,1.381,0,0,0,1.326,1.13l18.414-.1a1.136,1.136,0,0,0,1.129-1.156l-.005-.311a1.231,1.231,0,0,0-1.169-1.192Z",
    transform: "translate(-1635.249 -1693.152)",
    fill: "#eeeef2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8331",
    "data-name": "Path 8331",
    d: "M898.614,1927.908h-.019l-7-.031a1.881,1.881,0,0,1-1.928-1.59l-.645-5.867a1.275,1.275,0,0,1,.3-.961,1.537,1.537,0,0,1,1.068-.534h0c.589-.043,1.419-.118,2.3-.2,1.849-.167,4.152-.375,5.447-.4a1.955,1.955,0,0,1,1.966,1.36,29.343,29.343,0,0,1,.3,6.614A1.729,1.729,0,0,1,898.614,1927.908Zm-8.185-8.446a1,1,0,0,0-.694.342.742.742,0,0,0-.175.558l.645,5.867a1.346,1.346,0,0,0,1.4,1.111l7,.031h.014a1.192,1.192,0,0,0,1.249-1.077,29.206,29.206,0,0,0-.278-6.46,1.443,1.443,0,0,0-1.439-.965c-1.276.022-3.567.23-5.408.4-.881.08-1.713.155-2.306.2Z",
    transform: "translate(697.223 -90.29)",
    fill: "#eeeef2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8332",
    "data-name": "Path 8332",
    d: "M907.755,1936.48c1.469-.108,4.662-.449,6.177-.476a1.355,1.355,0,0,1,1.36.93,23.786,23.786,0,0,1,.23,5.224,1.164,1.164,0,0,1-1.225,1.071l-5.591-.024a1.292,1.292,0,0,1-1.328-1.079l-.516-4.688A.908.908,0,0,1,907.755,1936.48Z",
    transform: "translate(680.652 -106.707)",
    fill: "#eeeef2",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26611",
    "data-name": "Group 26611",
    transform: "translate(1601.901 1831.458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8333",
    "data-name": "Path 8333",
    d: "M1109.129,1968.583a1.737,1.737,0,0,0,1.7,1.285l64.728-.889a1.314,1.314,0,0,0-.019-2.627l-64.735.042A1.737,1.737,0,0,0,1109.129,1968.583Z",
    transform: "translate(-1109.068 -1966.352)",
    fill: "#eeeef2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8334",
    "data-name": "Path 8334",
    d: "M899.71,2138.6h-.019l-7-.031a1.881,1.881,0,0,1-1.928-1.59l-.646-5.867a1.275,1.275,0,0,1,.3-.961,1.535,1.535,0,0,1,1.068-.534h0c.589-.043,1.419-.119,2.3-.2,1.85-.167,4.151-.375,5.447-.4h.028a1.951,1.951,0,0,1,1.938,1.361,29.335,29.335,0,0,1,.3,6.614A1.729,1.729,0,0,1,899.71,2138.6Zm-8.185-8.446a1,1,0,0,0-.694.342.742.742,0,0,0-.175.558l.646,5.867a1.346,1.346,0,0,0,1.4,1.111l7,.031h.014a1.192,1.192,0,0,0,1.249-1.077,29.209,29.209,0,0,0-.278-6.461,1.436,1.436,0,0,0-1.439-.966c-1.276.023-3.567.23-5.408.4-.881.079-1.713.155-2.306.2Z",
    transform: "translate(696.205 -285.988)",
    fill: "#eeeef2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8335",
    "data-name": "Path 8335",
    d: "M908.851,2147.177c1.469-.108,4.662-.449,6.177-.475a1.354,1.354,0,0,1,1.36.929,23.779,23.779,0,0,1,.23,5.224,1.164,1.164,0,0,1-1.225,1.071l-5.591-.025a1.292,1.292,0,0,1-1.328-1.079l-.516-4.688A.909.909,0,0,1,908.851,2147.177Z",
    transform: "translate(679.635 -302.41)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26612",
    "data-name": "Group 26612",
    transform: "translate(1601.979 1846.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8336",
    "data-name": "Path 8336",
    d: "M1110.226,2179.28a1.737,1.737,0,0,0,1.7,1.285l64.728-.889a1.313,1.313,0,0,0-.019-2.627l-64.734.042A1.737,1.737,0,0,0,1110.226,2179.28Z",
    transform: "translate(-1110.166 -2177.049)",
    fill: "#eeeef2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8337",
    "data-name": "Path 8337",
    d: "M900.807,2349.3h-.019l-7-.031a1.88,1.88,0,0,1-1.928-1.589l-.646-5.866a1.277,1.277,0,0,1,.3-.962,1.535,1.535,0,0,1,1.068-.533h0c.589-.044,1.419-.119,2.3-.2,1.85-.167,4.152-.375,5.447-.4h.028a1.951,1.951,0,0,1,1.938,1.361,29.33,29.33,0,0,1,.3,6.614A1.729,1.729,0,0,1,900.807,2349.3Zm-8.185-8.446a.992.992,0,0,0-.694.342.742.742,0,0,0-.175.559l.646,5.866a1.345,1.345,0,0,0,1.4,1.111l7,.031h.014a1.192,1.192,0,0,0,1.249-1.077,29.208,29.208,0,0,0-.278-6.46,1.433,1.433,0,0,0-1.439-.966c-1.276.023-3.567.23-5.408.4-.881.079-1.713.155-2.306.2Z",
    transform: "translate(695.186 -481.69)",
    fill: "#eeeef2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8338",
    "data-name": "Path 8338",
    d: "M909.947,2357.875c1.469-.108,4.662-.449,6.177-.476a1.354,1.354,0,0,1,1.36.929,23.778,23.778,0,0,1,.23,5.224,1.164,1.164,0,0,1-1.225,1.071l-5.591-.024a1.293,1.293,0,0,1-1.328-1.08l-.516-4.688A.908.908,0,0,1,909.947,2357.875Z",
    transform: "translate(678.616 -498.112)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26613",
    "data-name": "Group 26613",
    transform: "translate(1602.057 1861.446)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8339",
    "data-name": "Path 8339",
    d: "M1111.322,2389.977a1.736,1.736,0,0,0,1.7,1.285l64.728-.889a1.313,1.313,0,0,0-.019-2.626l-64.734.041A1.737,1.737,0,0,0,1111.322,2389.977Z",
    transform: "translate(-1111.261 -2387.747)",
    fill: "#eeeef2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8340",
    "data-name": "Path 8340",
    d: "M901.9,2559.993h-.019l-7-.031a1.88,1.88,0,0,1-1.927-1.59l-.646-5.866a1.274,1.274,0,0,1,.3-.961,1.534,1.534,0,0,1,1.068-.534h0c.589-.043,1.419-.119,2.3-.2,1.849-.167,4.151-.376,5.447-.4h.028a1.95,1.95,0,0,1,1.938,1.36,29.339,29.339,0,0,1,.3,6.614A1.729,1.729,0,0,1,901.9,2559.993Zm-8.185-8.446a1,1,0,0,0-.694.342.742.742,0,0,0-.175.559l.646,5.867a1.345,1.345,0,0,0,1.4,1.111l7,.031h.014a1.192,1.192,0,0,0,1.249-1.077,29.206,29.206,0,0,0-.278-6.46,1.431,1.431,0,0,0-1.439-.966c-1.276.023-3.567.23-5.408.4-.881.08-1.713.155-2.306.2Z",
    transform: "translate(694.168 -677.393)",
    fill: "#eeeef2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8341",
    "data-name": "Path 8341",
    d: "M911.044,2568.571c1.469-.108,4.662-.449,6.177-.475a1.354,1.354,0,0,1,1.36.929,23.778,23.778,0,0,1,.23,5.224,1.164,1.164,0,0,1-1.225,1.071L912,2575.3a1.292,1.292,0,0,1-1.328-1.079l-.516-4.689A.908.908,0,0,1,911.044,2568.571Z",
    transform: "translate(677.597 -693.815)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26614",
    "data-name": "Group 26614",
    transform: "translate(1602.135 1876.441)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8342",
    "data-name": "Path 8342",
    d: "M1112.419,2600.674h0a1.738,1.738,0,0,0,1.7,1.285l64.728-.889a1.314,1.314,0,0,0-.019-2.627l-64.734.041A1.738,1.738,0,0,0,1112.419,2600.674Z",
    transform: "translate(-1112.358 -2598.443)",
    fill: "#eeeef2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8343",
    "data-name": "Path 8343",
    d: "M919.84,2522h0a1.073,1.073,0,0,1,1.483.395l1.393,2.467a.345.345,0,0,0,.615-.03l3.383-7.637a.382.382,0,0,1,.732.161,15.044,15.044,0,0,1-4.323,10.493s-2.057-.787-3.728-4.408A1.126,1.126,0,0,1,919.84,2522Z",
    transform: "translate(669.104 -646.322)",
    fill: "#396"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8344",
    "data-name": "Path 8344",
    d: "M914.627,2302.912h0a1.074,1.074,0,0,1,1.483.4l1.393,2.467a.345.345,0,0,0,.616-.03l3.383-7.638a.382.382,0,0,1,.731.161,15.041,15.041,0,0,1-4.323,10.492s-2.056-.787-3.728-4.407A1.127,1.127,0,0,1,914.627,2302.912Z",
    transform: "translate(673.946 -442.827)",
    fill: "#396"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8345",
    "data-name": "Path 8345",
    d: "M914.627,2092.661h0a1.073,1.073,0,0,1,1.483.395l1.393,2.467a.345.345,0,0,0,.616-.03l3.383-7.637a.382.382,0,0,1,.731.161,15.042,15.042,0,0,1-4.323,10.492s-2.056-.787-3.728-4.407A1.126,1.126,0,0,1,914.627,2092.661Z",
    transform: "translate(673.946 -247.538)",
    fill: "#396"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8346",
    "data-name": "Path 8346",
    d: "M919.84,1884.175h0a1.074,1.074,0,0,1,1.483.4l1.393,2.467a.345.345,0,0,0,.615-.03l3.383-7.638a.382.382,0,0,1,.732.161,15.043,15.043,0,0,1-4.323,10.492s-2.057-.787-3.728-4.408A1.127,1.127,0,0,1,919.84,1884.175Z",
    transform: "translate(669.104 -53.89)",
    fill: "#396"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingSuccessArt);
export default __webpack_public_path__ + "static/media/onboarding_success-art.db1ffd98799c3253869e722c6c12d91a.svg";
export { ForwardRef as ReactComponent };